/**
 * Spanish (Mexico). The reference catalog: every key exists here first.
 *
 * Tone: plain, direct, formal but not stiff. Correct accents and
 * capitalization throughout. Sentence case, not Title Case. No exclamation
 * marks. Nothing cute.
 */
export const esMX = {
    // Sign in
    'auth.title': 'Ingrese su NIP',
    'auth.staffCode': 'Clave de empleado',
    'auth.pin': 'NIP',
    'auth.signIn': 'Entrar',
    'auth.wrongPin': 'El NIP no coincide',
    'auth.attemptsLeft': 'Le quedan {count} intentos',
    'auth.locked': 'Cuenta bloqueada. Intente de nuevo en {minutes} minutos',
    'auth.offlineNotice': 'Sin conexión. Se validará localmente',
    'auth.unknownStaff': 'Clave de empleado no encontrada',
    'auth.selectStaff': 'Seleccione su nombre',
    'auth.noStaffSynced': 'Esta terminal aún no tiene personal sincronizado. Verifique el servidor y el token en Configuración y espere la primera sincronización',
    // Shift
    'shift.openTitle': 'Apertura de turno',
    'shift.openingBalance': 'Fondo de caja inicial',
    'shift.openingBalanceHelp': 'Cuente el efectivo con el que inicia y capture el monto',
    'shift.open': 'Abrir turno',
    'shift.closeTitle': 'Cierre de turno',
    'shift.closingBalance': 'Efectivo en caja al cerrar',
    'shift.closingBalanceHelp': 'Cuente todo el efectivo en la caja y capture el monto',
    'shift.close': 'Cerrar turno y salir',
    'shift.closeConfirm': 'Al cerrar el turno se cerrará su sesión en esta terminal',
    'shift.closed': 'Turno cerrado',
    'shift.elapsed': 'Turno abierto hace {duration}',
    'shift.mustOpen': 'Abra un turno para poder vender',
    'shift.invalidAmount': 'Capture un monto válido',
    // Catalog and cart
    'catalog.allCategories': 'Todo',
    'catalog.empty': 'No hay productos en esta categoría',
    'catalog.addProduct': 'Agregar {name}, {price}',
    'catalog.fromPrice': 'Desde {price}',
    'catalog.chooseProduct': 'Elegir {name}, desde {price}',
    'options.defaultLabel': 'Opciones',
    'options.mixHint': 'Se cobra la opción más cara de las elegidas',
    'options.mixPriceHint': '{count} o más sabores: {price}',
    'options.chosen': 'Elegido: {list}',
    'options.optional': '(opcional)',
    'options.extrasNeedFlavor': 'Elija al menos un sabor: el complemento va sobre un sabor',
    'options.add': 'Agregar',
    'catalog.each': 'c/u',
    'cart.title': 'Venta',
    'cart.empty': 'Agregue productos para iniciar la venta',
    'cart.items': 'Artículos',
    'cart.subtotal': 'Subtotal',
    'cart.discount': 'Descuento',
    'cart.comboCoffee': 'Café con platillo 50 %',
    'cart.promoFigJam': 'Mermelaana Higo 50 g gratis',
    'cart.total': 'Total',
    'cart.clear': 'Vaciar venta',
    'cart.clearConfirm': 'Se eliminarán todos los artículos de esta venta',
    'cart.clearConfirmWithPayments': 'Se eliminarán todos los artículos de esta venta y se quitarán los pagos en efectivo ya registrados',
    'cart.remove': 'Quitar',
    'cart.added': '{name} agregado a la venta',
    'cart.qty': 'Cantidad de {name}',
    'cart.decrease': 'Disminuir cantidad de {name}',
    'cart.increase': 'Aumentar cantidad de {name}',
    'cart.lineDiscount': 'Descuento al artículo',
    'cart.removeDiscount': 'Quitar descuento',
    'cart.orderDiscount': 'Descuento a la venta',
    'cart.pay': 'Cobrar',
    'held.hold': 'Retener venta',
    'held.open': 'Retenidas ({count})',
    'held.title': 'Ventas retenidas',
    'held.empty': 'No hay ventas retenidas',
    'held.heldAt': 'Retenida a las {time}',
    'held.resume': 'Retomar',
    'held.discard': 'Eliminar venta retenida',
    'held.discardConfirm': 'Se eliminará esta venta retenida y sus artículos. No se puede recuperar',
    'held.errorTitle': 'No se pudo completar',
    'held.errorBlocked': 'Esta venta tiene pagos registrados o un cobro con terminal en curso. Vaya a Cobrar, quite los pagos o descarte el cobro, y vuelva a intentarlo',
    'held.errorDiscardBlocked': 'Esta venta retenida tiene un pago con tarjeta o un cobro en la terminal; no se puede eliminar. Retómela para quitar el pago o terminarla',
    'held.discardConfirmWithPayments': 'Se eliminará esta venta retenida, sus artículos y los pagos en efectivo registrados. No se puede recuperar',
    'held.paid': 'Pagado {amount}',
    'held.chargePending': 'Cobro en la terminal pendiente',
    'shift.closeBlockedByHeld': 'Hay ventas retenidas con pagos registrados. Retómelas y termínelas, o quite sus pagos, antes de cerrar el turno',
    'held.errorFailed': 'No se pudo guardar o leer las ventas retenidas. No se perdió nada; intente de nuevo',
    // Discounts
    'discount.title': 'Aplicar descuento',
    'discount.percent': 'Porcentaje',
    'discount.amount': 'Monto',
    'discount.reason': 'Motivo',
    'discount.reasonRequired': 'Seleccione el motivo del descuento',
    'discount.selectReason': 'Seleccione un motivo',
    'discount.note': 'Nota',
    'discount.noteRequired': 'Este motivo requiere una nota',
    'discount.overCeiling': 'El descuento supera su límite de {pct}%',
    'discount.adminPin': 'NIP de autorización',
    'discount.adminPinHelp': 'Solicite a un administrador que capture su NIP',
    'discount.authorized': 'Autorizado por un administrador',
    'discount.resultingAmount': 'Descuento a aplicar',
    'discount.apply': 'Aplicar descuento',
    'discount.quick': 'Descuentos rápidos',
    'discount.customValue': 'Otro valor',
    'discount.fromSubtotal': 'desde',
    'discount.belowFloor': 'El descuento deja la venta por debajo del mínimo autorizado. Solicite el NIP de un administrador.',
    // Payment
    'payment.title': 'Cobro',
    'payment.remaining': 'Por cobrar',
    'payment.cash': 'Efectivo',
    'payment.card': 'Tarjeta',
    'payment.received': 'Recibido',
    'payment.change': 'Cambio',
    'payment.exact': 'Pago exacto',
    'payment.cardType': 'Tipo de tarjeta',
    'payment.credit': 'Crédito',
    'payment.debit': 'Débito',
    'payment.authNumber': 'Número de autorización',
    'payment.authNumberRequired': 'Capture el número de autorización',
    'payment.addPayment': 'Agregar pago',
    'payment.removePayment': 'Quitar pago',
    'payment.settled': 'Pago completo',
    'payment.overpaid': 'El monto excede lo que falta por cobrar',
    'payment.complete': 'Cobrar e imprimir',
    'payment.mixedHint': 'Puede combinar efectivo y una o más tarjetas',
    'payment.quickTenders': 'Montos sugeridos',
    'payment.amount': 'Monto',
    'payment.completed': 'Venta completada',
    'payment.printedOk': 'Ticket impreso',
    'payment.returningIn': 'Volviendo a la venta en {count} s',
    'kitchen.nameTitle': 'Nombre para la comanda',
    'kitchen.nameLabel': 'Nombre del cliente (opcional)',
    'kitchen.namePlaceholder': 'Ej. Ana',
    'kitchen.print': 'Imprimir comanda',
    'kitchen.printNoName': 'Sin nombre',
    'payment.kitchenSend': 'Enviar comanda a cocina',
    'payment.kitchenSending': 'Imprimiendo comanda…',
    'payment.kitchenSent': 'Comanda enviada a cocina',
    'payment.kitchenFailed': 'No se pudo imprimir la comanda. Revise la impresora e intente de nuevo',
    'ticket.kitchenTitle': 'COMANDA',
    'ticket.kitchenReprint': 'REIMPRESIÓN',
    'ticket.reprintKitchenAction': 'Reimprimir comanda',
    'history.reprintKitchenSuccess': 'Comanda reimpresa',
    'history.reprintKitchenFailed': 'No se pudo reimprimir la comanda',
    'payment.newSale': 'Nueva venta',
    // Payment terminal push (Mercado Pago Point Smart / Clip Total, 2026-10-15)
    'payment.terminalPush.button': 'Cobrar con terminal',
    'payment.terminalPush.pickTitle': '¿Con qué terminal?',
    'payment.terminalPush.resumeTitle': 'Hay un cobro con terminal pendiente',
    'payment.terminalPush.resumeBody': 'Se envió {amount} a una terminal y no se confirmó el resultado. Puede seguir esperando esa respuesta o descartarlo e intentar de nuevo.',
    'payment.terminalPush.resume': 'Seguir esperando',
    'payment.terminalPush.discard': 'Descartar',
    'payment.terminalPush.checking': 'Verificando el estado del cobro…',
    'payment.terminalPush.discardConfirmBody': 'No se pudo confirmar si el cobro ya se completó en la terminal. Descartarlo no cancela un cobro que sí haya llegado — solo deja de avisarle sobre él.',
    'payment.terminalPush.discardConfirmForce': 'Descartar de todas formas',
    'payment.terminalPush.discardConfirmKeep': 'No, no descartar',
    'payment.terminalPush.waiting': 'Esperando el cobro en la terminal…',
    'payment.terminalPush.waitingAmount': 'Pida al cliente tocar o insertar su tarjeta',
    'payment.terminalPush.cancel': 'Cancelar',
    'payment.terminalPush.timedOut': 'La terminal está tardando más de lo normal. Puede seguir esperando o cancelar.',
    'payment.terminalPush.cardTypePrompt': '¿Crédito o débito?',
    'payment.terminalPush.declined': 'La terminal rechazó el cobro',
    'payment.terminalPush.cancelled': 'El cobro fue cancelado en la terminal',
    'payment.terminalPush.expired': 'El cobro expiró sin respuesta de la terminal',
    'payment.terminalPush.error': 'No se pudo confirmar el resultado del cobro. Puede que la terminal ya lo haya recibido',
    'payment.terminalPush.mismatchTitle': 'El cobro no corresponde a la venta actual',
    'payment.terminalPush.mismatchBody': 'Se aprobó un cobro de {amount} en {terminal} (ref. {ref}), pero no corresponde al total de esta venta. Avise a un administrador para reconciliarlo manualmente indicando esa referencia.',
    'payment.terminalPush.mismatchDiscard': 'Descartar este cobro',
    'payment.terminalPush.mismatchDiscardConfirmBody': 'Este cobro de {amount} en {terminal} (ref. {ref}) SÍ se completó en la terminal. Descartarlo aquí no cancela el cobro ni el dinero recibido — solo deja de rastrearlo en este dispositivo. Avise a un administrador para conciliarlo manualmente indicando esa referencia.',
    'payment.terminalPush.retry': 'Reintentar',
    'payment.terminalPush.manualEntry': 'Ingresar manualmente',
    // Tickets
    'ticket.folio': 'Folio',
    'ticket.date': 'Fecha',
    'ticket.attendedBy': 'Le atendió',
    'ticket.terminal': 'Terminal',
    'ticket.subtotal': 'Subtotal',
    'ticket.discount': 'Descuento',
    'ticket.total': 'Total',
    'ticket.cash': 'Efectivo',
    'ticket.card': 'Tarjeta',
    'ticket.credit': 'Crédito',
    'ticket.debit': 'Débito',
    'ticket.auth': 'Autorización',
    'ticket.tendered': 'Recibido',
    'ticket.change': 'Cambio',
    'ticket.items': 'Artículos',
    'ticket.reprint': 'REIMPRESIÓN',
    'ticket.voided': 'CANCELADA',
    'ticket.copy': 'copia',
    'ticket.printing': 'Imprimiendo',
    'ticket.printFailed': 'No se pudo imprimir. La venta quedó registrada',
    'ticket.reprintAction': 'Reimprimir ticket',
    'ticket.noPrinter': 'No se detectó la impresora',
    // History
    'history.title': 'Ventas anteriores',
    'history.search': 'Buscar por folio o monto',
    'history.empty': 'No hay ventas registradas',
    'history.noResults': 'No encontramos ventas con esos datos',
    'history.void': 'Cancelar venta',
    'history.voidReason': 'Motivo de la cancelación',
    'history.voidReasonRequired': 'Capture el motivo de la cancelación',
    'history.voidConfirm': 'La venta quedará cancelada. Esta acción no se revierte',
    'history.voidedLabel': 'Cancelada',
    'history.synced': 'Sincronizada',
    'history.notSynced': 'Pendiente de sincronizar',
    'history.detailTitle': 'Detalle de la venta',
    'history.reprintSuccess': 'Ticket reimpreso',
    'history.reprintFailed': 'No se pudo reimprimir el ticket',
    // Reports
    'reports.title': 'Reportes',
    'reports.today': 'Hoy',
    'reports.week': 'Esta semana',
    'reports.month': 'Este mes',
    'reports.custom': 'Periodo',
    'reports.grossSales': 'Venta bruta',
    'reports.netSales': 'Venta neta',
    'reports.transactions': 'Transacciones',
    'reports.itemsSold': 'Artículos vendidos',
    'reports.discounts': 'Descuentos',
    'reports.averageTicket': 'Ticket promedio',
    'reports.byPaymentMethod': 'Por forma de pago',
    'reports.topItems': 'Más vendidos',
    'reports.noData': 'No hay datos en este periodo',
    'reports.item': 'Producto',
    'reports.units': 'Unidades',
    'reports.amount': 'Importe',
    'reports.range.from': 'Desde',
    'reports.range.to': 'Hasta',
    'reports.range.apply': 'Aplicar',
    // Sync and connectivity
    'sync.online': 'En línea',
    'sync.offline': 'Sin conexión',
    'sync.pending': '{count} por sincronizar',
    'sync.syncing': 'Sincronizando',
    'sync.lastSync': 'Última sincronización {time}',
    'sync.never': 'Sin sincronizar',
    'sync.now': 'Sincronizar ahora',
    'sync.failed': 'No se pudo sincronizar',
    'sync.dead': '{count} registros requieren atención',
    'sync.clockDrift': 'La hora de la terminal está desfasada. Avise al administrador',
    // App shell
    'app.error.title': 'Ocurrió un problema',
    'app.error.body': 'La aplicación tuvo un error inesperado. Su venta en curso no se perdió.',
    'app.error.reload': 'Recargar',
    // Settings
    'settings.title': 'Configuración',
    'settings.adminGateTitle': 'Configuración protegida',
    'settings.adminGateHelp': 'La configuración de la terminal es solo para administradores. Capture el NIP de un administrador para continuar.',
    'settings.adminGateSubmit': 'Verificar NIP',
    'settings.terminalName': 'Nombre de la terminal',
    'settings.terminalId': 'Identificador de terminal',
    'settings.terminalToken': 'Token de conexión',
    'settings.terminalTokenHelp': 'Proporcionado por el administrador para vincular esta terminal',
    'settings.terminalTokenSave': 'Guardar token',
    'settings.provisioningWaiting': 'Esperando aprobación del administrador…',
    'settings.provisioningRejected': 'El administrador rechazó esta terminal. Puede ingresar un token manualmente o pedir que la vuelvan a aprobar.',
    'settings.provisioningManualFallback': 'Si lo prefiere, también puede ingresar el token manualmente:',
    'settings.serverUrl': 'Servidor de sincronización',
    'settings.serverUrlHelp': 'Dirección completa con https://, sin diagonal final. Cambiarla requiere reiniciar la aplicación',
    'settings.language': 'Idioma',
    'settings.theme': 'Tema',
    'settings.themeHelp': 'Aspecto de la pantalla en este dispositivo',
    'settings.themeDark': 'Oscuro',
    'settings.themeLight': 'Claro',
    'settings.debugMode': 'Modo de depuración',
    'settings.debugModeHelp': 'Activa registros detallados en este dispositivo',
    'settings.printerStatus': 'Estado de la impresora',
    'settings.printerReady': 'Lista',
    'settings.printerNotReady': 'No disponible',
    'settings.printerTest': 'Imprimir ticket de prueba',
    'settings.printerTestLabel': 'Ticket de prueba',
    'settings.printerTestSent': 'Ticket de prueba enviado',
    'settings.diagnosticsTitle': 'Diagnóstico',
    'settings.diagnosticsHelp': 'Estos registros se envían al sincronizar para ayudar a resolver problemas',
    'settings.syncTitle': 'Sincronización',
    'settings.syncAllSent': 'Todo está sincronizado con el servidor',
    'settings.syncPending': '{count} operaciones guardadas en la terminal, por enviar al servidor',
    'settings.deadSyncTitle': 'Registros con error de sincronización',
    // "rechazado", not "pendiente": this line coexists on screen with the
    // outbox count above it, and its old copy ("No hay registros pendientes
    // de revisión") read as "nothing pending to sync" while 14 envelopes
    // waited offline (2026-08-01).
    'settings.deadSyncEmpty': 'Ningún registro ha sido rechazado por el servidor',
    'settings.deadSyncCount': '{count} registros requieren atención',
    'settings.saved': 'Cambios guardados',
    // Self-update (2026-07-31)
    'settings.updateTitle': 'Actualización de la aplicación',
    'settings.updateVersion': 'Versión {versionName} ({versionCode})',
    'settings.updateVersionWeb': 'Compilación web',
    'settings.checkUpdate': 'Buscar actualización',
    'settings.updateUpToDate': 'Ya tiene la versión más reciente',
    'settings.updateAvailableRow': 'Nueva versión disponible: {versionName}',
    'update.title': 'Actualización disponible',
    'update.available': 'Nueva versión disponible: {versionName}. ¿Actualizar ahora?',
    'update.size': 'Tamaño: {size}',
    'update.updateNow': 'Actualizar',
    'update.downloading': 'Descargando… {percent}%',
    'update.verifying': 'Verificando…',
    'update.installing': 'Abriendo instalador…',
    'update.done': 'Instalador abierto',
    'update.errorDownloadFailed': 'No se pudo descargar la actualización. Revise su conexión e intente de nuevo',
    'update.errorChecksumMismatch': 'El archivo descargado no coincide con lo publicado. Intente de nuevo',
    'update.errorInstallPermissionRequired': 'Active "Instalar apps desconocidas" para esta aplicación en Ajustes y vuelva a intentarlo',
    'update.errorInstallFailed': 'No se pudo abrir el instalador. Intente de nuevo',
    'update.errorUnknown': 'No se pudo completar la actualización. Intente de nuevo',
    'update.openInstallSettings': 'Abrir ajustes de instalación',
    'shiftBar.updateShort': 'Actualización',
    'shiftBar.updateAvailable': 'Actualización disponible: {versionName}. Toca para instalar',
    // Numeric keypad
    'keypad.decimal': 'Punto decimal',
    'keypad.clear': 'Borrar todo',
    'keypad.clearShort': 'C',
    'keypad.backspace': 'Borrar último dígito',
    // Navigation
    'nav.label': 'Navegación principal',
    'nav.sale': 'Venta',
    'nav.history': 'Historial',
    'nav.reports': 'Reportes',
    'nav.settings': 'Configuración',
    'nav.closeShift': 'Cerrar turno',
    'nav.switchUser': 'Cambiar de usuario',
    'auth.switchUserTitle': 'Cambiar de usuario',
    'auth.switchUserHint': 'El turno abierto por {name} y el efectivo del cajón continúan igual. Las nuevas ventas se registran a nombre de quien entre.',
    // Generic
    'common.cancel': 'Cancelar',
    'common.confirm': 'Confirmar',
    'common.back': 'Volver',
    'common.save': 'Guardar',
    'common.delete': 'Eliminar',
    'common.edit': 'Editar',
    'common.close': 'Cerrar',
    'common.signOut': 'Cerrar sesión',
    'common.loading': 'Cargando',
    'common.error': 'Ocurrió un error',
    'common.retry': 'Reintentar',
    'common.required': 'Campo obligatorio',
    // stock & media
    'catalog.stockAvailable': '{count} disponibles',
    'catalog.stockOut': 'Sin existencia',
    'catalog.stockOversold': '{count} vendidos de más',
};
//# sourceMappingURL=es-MX.js.map